'use strict';

var HelpPageUrlService = function HelpPageUrlService(configurationService, featureToggle) {
  var DEFAULT_URL = '/help';
  var MAIN_PAGE = '/Default.htm';
  var PAGE_MAPPING = {
    'dashboard': 'revenue_optimizer/dashboard/dashboard.htm',
    'market-analysis': 'revenue_optimizer/market_analysis/market_analysis.htm',
    'flight-analysis': 'revenue_optimizer/flight_analysis/flight_analysis.htm',
    'rom-analysis': 'revenue_optimizer/ROM/rom_analysis_view.htm',
    'rom-summary': 'revenue_optimizer/ROM/rom_summary_view.htm',
    'rules': 'revenue_optimizer/rules_and_strategies/rules_and_strategies.htm',
    'strategies': 'revenue_optimizer/rules_and_strategies/rules_and_strategies.htm',
    'data-extract': 'revenue_optimizer/data_extract/data_extract.htm',
    'schedule-change': 'revenue_optimizer/admin/schedule_change/schedule_change.htm',
    'seasonality': 'revenue_optimizer/admin/seasonality/seasonality.htm',
    'user-management': 'revenue_optimizer/admin/user_management/user_management.htm',
    'system-status': 'revenue_optimizer/admin/system_status/system_status.htm',
    'system-configuration': 'revenue_optimizer/admin/system_configuration/system_configuration.htm',
    //DA
    'pricing-summary': 'dynamic_availability/da_dashboard.htm',
    'pricing-analysis': 'dynamic_availability/departure_date_upsell.htm',
    //FO
    'fares-optimizer-analysis': 'fares_optimizer/fares_optimizer_overview.htm'
  };
  function getApplicationRoute() {
    if (featureToggle.isEnabled('REVENUE_OPTIMIZER')) {
      return '/RO';
    } else if (featureToggle.isEnabled('FARES_OPTIMIZER')) {
      return '/FO';
    } else if (featureToggle.isEnabled('DYNAMIC_AVAILABILITY')) {
      return '/DA';
    } else {
      return '';
    }
  }
  function getHelpUrl() {
    return configurationService.getHelpUrl() || DEFAULT_URL + getApplicationRoute();
  }
  function getPageUrl(id) {
    var url = MAIN_PAGE;
    var page = PAGE_MAPPING[id];
    if (page) {
      url = url.concat('#' + page);
    }
    return url;
  }
  function getUrl(id) {
    return getHelpUrl() + getPageUrl(id);
  }
  return {
    getUrl: getUrl
  };
};
HelpPageUrlService.$inject = ['ConfigurationService', 'FeatureToggleService'];
module.exports = HelpPageUrlService;